import React from 'react';
import { Box, Heading, Body } from '@hover/blueprint';

const FPHeading = () => (
  <Box d="block" textAlign="center">
    <Heading
      mb={{ base: 2, desktop: 8 }}
      size={{ base: 400, tablet: 600, desktop: 700 }}
    >
      Featured Partners
    </Heading>
    <Body size={600}>
      Learn more about the real results that HOVER is driving through
      partnerships.
    </Body>
  </Box>
);

export default FPHeading;
